module.exports = __webpack_public_path__ + "media/7.fb1a5c27.mp3";